import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLayout } from './LayoutContext';
import { titleForPath, isAdminPath } from './navConfig';
import { MenuIcon } from './icons';
import './TopBar.css';

export function TopBar() {
  const location = useLocation();
  const { setMobileOpen } = useLayout();
  const title = titleForPath(location.pathname);
  const showCrumb = isAdminPath(location.pathname) && location.pathname !== '/admin';

  return (
    <header className="topbar">
      <button
        type="button"
        className="topbar-menu"
        onClick={() => setMobileOpen(true)}
        aria-label="Open navigation"
      >
        <MenuIcon />
      </button>
      <div className="topbar-title">
        {showCrumb && <span className="topbar-crumb">Admin / </span>}
        <h1>{title}</h1>
      </div>
      <div className="topbar-actions" />
    </header>
  );
}
